import React from "react";

import "./src/styles/bootstrap.scss";
import "./src/styles/default.scss";

const WrapWithProviders = ({ children }) => <>{children}</>;

export default WrapWithProviders;
